/** @file Registers the history chords for the live project; returns the unregister function. */
import { registerEffective } from '../../shell/shortcuts/registerEffective';
import { bindings } from './bindings';
import { history } from './history';

/** Global context through registerEffective (W3-25), so the user's overrides apply; typing in an input keeps the
 *  browser's own undo (the shortcuts package skips inputs). */
export function installHistory(): () => void {
  const undo = (): void => {
    void history.undo();
  };
  const redo = (): void => {
    void history.redo();
  };
  return registerEffective('global', bindings, { 'history.undo': undo, 'history.redo': redo, 'history.redoAlt': redo });
}
